function mark(entry) {
    const codes = [entry.absence_code, entry.travel_code].filter(Boolean);
    return [Number(entry.worked_minutes) > 0 || !codes.length
        ? `${(Number(entry.worked_minutes || 0) / 60).toLocaleString('ru-RU').replace('.', ',')} ч.` : '', ...codes]
        .filter(Boolean).join(' / ');
}

function sourceName(entry) {
    if (!entry.object_visible) return 'Другой табель (нет доступа)';
    return entry.object && entry.object.name ? `Табель «${entry.object.name}»` : `Табель №${entry.timesheet_id}`;
}

function text(entry) {
    return `${sourceName(entry)}: ${mark(entry)}. ${entry.author_user_id
        ? `Отметку поставил: ${entry.author_name}` : entry.author_name || 'Кто поставил отметку — неизвестно'}.`;
}

function route(entry) {
    if (!entry.object_visible || !entry.timesheet_id) return null;
    return {name: 'timesheet', params: {timesheetId: String(entry.timesheet_id)}, query: {
        from: 'review', month: String(entry.work_date).slice(0, 7),
        ...(entry.review_revision ? {review_revision: String(entry.review_revision)} : {}),
        ...(entry.line_id ? {review_line: String(entry.line_id)} : {}), review_date: entry.work_date
    }};
}

module.exports = {mark, sourceName, text, route};
